export const VERSION = typeof "3.0.13" !== 'undefined' ? "3.0.13" : 'latest';
//# sourceMappingURL=version.js.map